import type { ReactElement } from 'react'

import {
  LiveRegion,
  Panel,
  PillButton,
  PillLink,
} from '@maria-cavalheiro-website/shared-ui-web'

import { SHARE_LINKS, SHARE_TEXT, SHARE_TITLE, SHARE_URL } from './share-links.ts'
import { useShare } from './use-share.ts'

export interface ShareSectionProps {
  readonly headingId: string
}

const EYEBROW = 'Compartilhar'
const TITLE = 'Se um poema te lembrou de algo, mande para quem precisa ler.'

/**
 * Constant on server and client alike. The design derived it from
 * `navigator.share` at render time, which a prerendered document cannot do without
 * a hydration mismatch and a visible width change.
 */
const SHARE_BUTTON_LABEL = 'Compartilhar'

export function ShareSection({ headingId }: ShareSectionProps): ReactElement {
  const { message, share } = useShare({
    title: SHARE_TITLE,
    text: SHARE_TEXT,
    url: SHARE_URL,
  })

  return (
    <Panel variant="highlight" className="share">
      <p className="share__eyebrow">{EYEBROW}</p>

      <h2 className="share__title" id={headingId}>
        {TITLE}
      </h2>

      <div className="share__actions">
        {SHARE_LINKS.map((link) => (
          <PillLink
            key={link.network}
            href={link.href}
            external
            icon={link.icon}
            accessibleName={link.action}
          >
            {link.network}
          </PillLink>
        ))}

        <PillButton variant="secondary" onClick={share} icon="share">
          {SHARE_BUTTON_LABEL}
        </PillButton>
      </div>

      {/* Present from first paint, empty. A live region inserted at the moment of
          its announcement is frequently missed; the design put this text in a bare
          <span>, so "Link copiado." was never announced at all. */}
      <LiveRegion message={message} className="share__feedback" />
    </Panel>
  )
}
